import React from 'react';
import Section from '../ui/Section';
import { motion } from 'framer-motion';

const MethodologySection = () => {
  return (
    <Section bg="cream" className="py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="w-full lg:w-1/2">
            <motion.div 
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold text-brand-navy mb-6">Leadership before technology.</h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  Leading AI well starts with leadership, not software. We believe technology should serve your mission, not reshape it by default.
                </p>
                <p>
                  We help leaders understand where AI adds value, where people should remain at the centre, and how to build organisational habits that are practical, responsible, and sustainable.
                </p>
              </div>
            </motion.div>
          </div>
          
          <div className="w-full lg:w-1/2 relative">
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="relative z-10 rounded-[2.5rem] overflow-hidden shadow-2xl"
            >
              <img 
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=1200" 
                alt="Strategic Leadership Session" 
                className="w-full h-auto object-cover"
              />
            </motion.div>
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-brand-teal/10 rounded-full blur-3xl -z-0"></div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default MethodologySection;